<template>
    <div>
        中国供应商-搜索
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    methods: {},
    mounted() {},
};
</script>

<style lang='scss' scoped>

</style>